$(document).ready(function(){


    
    $('body').on("submit", ".form_product_on_homepage", function(event){
        event.preventDefault();
        
        document.dispatchEvent(new Event('theme:loading:start'));
        var _this = $(this);
        var added_text = _this.find('button').attr("data-added_rel");    

        $.ajax({
            "method": "POST",
            "dataType": "json",
            "url": '/cart/add.js',
            "data":  _this.serialize(),
            "success": function(){
                _this.closest(".related-products__box").addClass('active');
                _this.find('button').html(added_text);

                $.get(window.location.href, function(html){
                    _this.closest(".related-products__wrap").html($(html).find('.related-products__wrap').html());
                });

                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                    bubbles: true
                })); 

                document.querySelector('.Header__CartDot').classList.add('is-visible');
            },
            "error": function(jqXHR, textStatus, errorThrown){
                var response = $.parseJSON(jqXHR.responseText);
                _this.append('<p class="alert">'+response.description+'</p>').find('.error').fadeIn();

                setTimeout(function(){
                    _this.find('.alert').fadeOut()
                },4000);
                            
              }
        });
        
       
    });


});